import { createContext } from 'react';

export const ContextFormData = {
  isProjectRegisterForm: true,
  activeProjectStep: 0,
  projectType: '',
};

export const ContextForm = createContext(ContextFormData);
